import { isPessoaJuridica } from "./clientName";
import { readWorkspaceLocal, writeWorkspaceLocal } from "./workspaceStorage";

export const AWARENESS_PERSON_FILTERS = {
  ALL: "all",
  PF: "pf",
  PJ: "pj",
};

const STORAGE_BASE = "awareness_person_type";

export function normalizeAwarenessPersonFilter(value) {
  const v = String(value || "").trim().toLowerCase();
  if (v === AWARENESS_PERSON_FILTERS.PF || v === AWARENESS_PERSON_FILTERS.PJ) return v;
  return AWARENESS_PERSON_FILTERS.ALL;
}

export function awarenessPersonFilterStorageKey(userId) {
  const id = Number(userId);
  return Number.isFinite(id) && id > 0 ? `${STORAGE_BASE}:${id}` : STORAGE_BASE;
}

export function readAwarenessPersonFilter(userId) {
  const id = Number(userId);
  if (!Number.isFinite(id) || id <= 0) return AWARENESS_PERSON_FILTERS.ALL;
  return normalizeAwarenessPersonFilter(readWorkspaceLocal(awarenessPersonFilterStorageKey(id)));
}

export function writeAwarenessPersonFilter(userId, value) {
  const id = Number(userId);
  if (!Number.isFinite(id) || id <= 0) return;
  writeWorkspaceLocal(
    awarenessPersonFilterStorageKey(id),
    normalizeAwarenessPersonFilter(value)
  );
}

/** Alinha com o filtro da API (`tipo` 0=PF, 1/2=PJ). Evita CNPJ residual esconder PF. */
export function clientMatchesAwarenessPersonFilter(client, personType) {
  const tipoPessoa = normalizeAwarenessPersonFilter(personType);
  if (tipoPessoa === AWARENESS_PERSON_FILTERS.ALL) return true;

  const tipoRaw = client?.tipo ?? client?.clientType ?? client?.client_type;
  if (tipoRaw != null && tipoRaw !== "") {
    const tipo = Number(tipoRaw);
    if (Number.isFinite(tipo)) {
      if (tipoPessoa === AWARENESS_PERSON_FILTERS.PF) return tipo === 0;
      if (tipoPessoa === AWARENESS_PERSON_FILTERS.PJ) return tipo === 1 || tipo === 2;
    }
  }

  if (tipoPessoa === AWARENESS_PERSON_FILTERS.PJ) return isPessoaJuridica(client);
  return !isPessoaJuridica(client);
}
